import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7f340ed0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7f340ed0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f340ed0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f340ed0')) {
      api.createRecord('7f340ed0', component.options)
    } else {
      api.reload('7f340ed0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7f340ed0&scoped=true", function () {
      api.rerender('7f340ed0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operatingPlatform/ChangeSingleCollectionBag/index.vue"
export default component.exports